module.exports = __webpack_public_path__ + "assets/exit.b0ad4276.svg";